'use client'

import { usePathname, useSearchParams } from 'next/navigation'

import { YandexMetrics } from '@/shared/integrations/yandex-metric'
import { HumanOnly } from '@/shared/lib/seo/bot/HumanOnly'
import { NavigationTrackingProvider } from '@/shared/navigation'

export const Analytics = () => {
	const pathname = usePathname()
	const searchParams = useSearchParams()
	const search = searchParams.toString()
	const asPath = `${pathname}${search ? `?${search}` : ''}`

	return (
		<>
			<NavigationTrackingProvider />
			<HumanOnly>
				<YandexMetrics ymID="10760449" path={asPath} />
			</HumanOnly>
		</>
	)
}
